import React from "react";
import { Box, CircularProgress, IconButton, Paper } from "@material-ui/core";
import { PermissionWrapper, Thumbnail } from "components";
import { ReadOnlyField } from "components/SchemaProvider";
import { Asset as AssetViewModelProps } from "api/factories";
// TODO: this container must be moved to "components"
import { CreativeToolbarContainer } from "pages/MaterialSpecs/components/CreativesSection/CreativeToolbar/CreativeToolbar.styled";
import { API } from "api";
import GetAppIcon from "@material-ui/icons/GetApp";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { useTranslation } from "react-i18next";

interface AssetDetailsProps extends AssetViewModelProps {
    isDeleting: boolean;
    isDownloading: boolean;
    onDeleteAsset(id: number): void;
    onDownloadAsset(id: number): void;
}

export const AssetDetails = ({
    id,
    preview,
    inputFileName,
    size,
    modificationDate,
    permissions,
    isDeleting,
    isDownloading,
    onDeleteAsset,
    onDownloadAsset,
}: AssetDetailsProps) => {
    const { t } = useTranslation();

    return (
        <Box display="flex" component={Paper} marginY={1} position="relative" alignItems="center" boxShadow={3}>
            <CreativeToolbarContainer position="absolute" bottom="8px" right="8px">
                <PermissionWrapper name="DOWNLOAD" permissions={permissions}>
                    {({ disabled }) => (
                        <IconButton onClick={() => onDownloadAsset(id)} disabled={isDownloading || disabled}>
                            <GetAppIcon color="inherit" />
                        </IconButton>
                    )}
                </PermissionWrapper>
                <PermissionWrapper name="DELETE" permissions={permissions}>
                    {({ disabled }) => (
                        <IconButton onClick={() => onDeleteAsset(id)} disabled={isDeleting || disabled}>
                            <DeleteOutlinedIcon color="inherit" />
                        </IconButton>
                    )}
                </PermissionWrapper>
            </CreativeToolbarContainer>
            <Box width="100px" height="100px" display="flex" alignItems="center" justifyContent="center" p={1}>
                {preview ? <Thumbnail src={`${API.serverUrl}${preview.url}`} /> : <CircularProgress />}
            </Box>
            <Box display="flex" minWidth={0} flex={1}>
                <Box flexDirection="column" paddingX={1} flex={1} minWidth={0}>
                    <ReadOnlyField
                        caption={t("campaign.assets.label.fileName")}
                        label={inputFileName}
                        bold
                        tooltip={inputFileName}
                    />
                    <ReadOnlyField caption={t("campaign.assets.label.dimensions")} label={size} bold />
                </Box>
                <Box flexDirection="column" paddingX={1} flex={1} minWidth={0}>
                    <ReadOnlyField
                        caption={t("campaign.assets.label.modificationDate")}
                        label={modificationDate}
                        bold
                    />
                    {preview && (
                        <ReadOnlyField
                            caption={t("campaign.assets.label.fileType")}
                            label={preview.format.toUpperCase()}
                            bold
                        />
                    )}
                </Box>
            </Box>
        </Box>
    );
};
